import {Contacto} from './contacto.model';
import {DetailField} from "../../shared";

export interface ContactoDetailParams {
  contacto: Contacto;
  fields?: DetailField[];
}
